<template>
  <gs-modal
    :value="open"
    size="xl"
    :title="video && video.name"
    class="gs-preview-modal"
    :class="{ 'gs-preview-modal--portrait': portrait }"
    @input="$emit('close')"
    @close="$emit('close')"
  >
    <div class="gs-preview-modal__body">
      <div v-if="video && open" class="gs-preview-modal__player" :style="playerColor">
        <video-player
          id="vid2"
          :options="video"
          class="gs-preview-modal__video video-js vjs-big-play-centered"
          :class="vjsClass"
          data-setup='{ "playbackRates": [0.5, 1, 1.25, 1.5, 1.75, 2] }'
        ></video-player>
      </div>
      <div class="gs-preview-modal__footer">
        <gs-button variant="outline" @click="$emit('edit', video)">
          <gs-icon name="edit" size="16" />
          Edit video
        </gs-button>
        <gs-button variant="outline" @click="$emit('share', video)">
          <gs-icon name="share" size="16" />
          Share
        </gs-button>
      </div>
    </div>
  </gs-modal>
</template>

<script>
import { videoFormat } from '@/player/videoFormat';
import VideoPlayer from '../../pages/videos/VideoPlayer';

export default {
  name: 'PreviewVideoModal',
  components: { VideoPlayer },
  props: {
    video: {
      type: Object,
      default: null,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    portrait() { return videoFormat(this.video) === '9:16'; },
    playerColor() {
      if (
        this.video &&
        this.video.settings &&
        typeof this.video.settings.color !== 'undefined' &&
        typeof this.video.settings.color.primary !== 'undefined' &&
        typeof this.video.settings.color.secondary !== 'undefined'
      ) {
        return {
          '--player-primary-color': this.video.settings.color.primary,
          '--player-secondary-color': this.video.settings.color.secondary,
        };
      }
      return {
        '--player-primary-color': 'rgba(253, 100, 129, 0.8)',
        '--player-secondary-color': 'rgba(255,255,255, 1)',
      };
    },
    vjsClass() {
      if (!this.video || !this.video.settings) {
        return 'vjs-theme-default';
      }
      if (this.video.settings.theme == null || this.video.settings.theme === ' ') {
        return 'vjs-theme-default';
      }
      if (this.video.settings.theme !== ' ') {
        return this.video.settings.theme;
      }
      return '';
    },
  },
};
</script>

<style scoped>
.gs-preview-modal ::v-deep .gs-modal__panel {
  width: min(1200px, 96vw, calc((90vh - 160px) * 16 / 9 + 40px));
}
.gs-preview-modal__video {
  width: 100% !important;
  height: auto !important;
  min-width: 0;
}
.gs-preview-modal__player ::v-deep .video-internal-wrapper {
  max-height: none;
}
.gs-preview-modal__player ::v-deep .vjs-fluid {
  width: 100% !important;
  height: 0 !important;
}
.gs-preview-modal.gs-preview-modal--portrait ::v-deep .gs-modal__panel { width: min(520px, 96vw, calc((90vh - 160px) * 9 / 16 + 40px)); }
@media (max-width: 640px) {
  .gs-preview-modal ::v-deep .gs-modal__panel { width: 100%; }
  .gs-preview-modal__body { padding: 12px !important; gap: 12px !important; }
}

.gs-preview-modal__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px 20px 20px;
}

.gs-preview-modal__player {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  border-radius: var(--gs-radius-md);
}

.gs-preview-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
